import React, { useState } from "react";
import "./MappingScreen.css";
import MappingHeader from "../../presentation/mapping/MappingHeader";
import Breadcrumb from "../../../components/bootstrap/Breadcrumb";
import Select from "../../../components/bootstrap/forms/Select";
import FormGroup from "../../../components/bootstrap/forms/FormGroup";
import Input from "../../../components/bootstrap/forms/Input";
import Card, { CardBody, CardHeader } from "../../../components/bootstrap/Card";
import { CardMembership } from "@mui/icons-material";
import Button from "../../../components/bootstrap/Button";
import Checks from "../../../components/bootstrap/forms/Checks";
import ToastComponent from "../../../components/ToastComponent";
import {
  showSuccessToast,
  showErrorToast,
  showWarningToast,
} from "../../../components/ToastComponent";
const MappingScreen = (props: any) => {
  const vyu_api_url: any = process.env.REACT_APP_VYU_API_URL;
  const vyu_service_url = process.env.REACT_APP_VYU_SERVICE_URL;
  const [dropdown1Value, setDropdown1Value] = useState<string>("");
  const [dropdown2Value, setDropdown2Value] = useState<string>("");
  const [namesForDropdown1, setNamesForDropdown1] = useState<any[]>([]);
  const [namesForDropdown2, setNamesForDropdown2] = useState<any[]>([]);
  const [availableMappings, setAvailableMappings] = useState<any[]>([]);
  const [searchInput1, setSearchInput1] = useState<string>("");
  const [searchInput2, setSearchInput2] = useState<string>("");
  const [searchInput3, setSearchInput3] = useState<string>("");
  const [showAvailableMapping, setShowAvailableMapping] =
    useState<boolean>(false);
  const [showMappingDiv, setShowMappingDiv] = useState<boolean>(false);
  const section1Values = ["User", "Dashboard", "Tab", "Widget"];
  const section2Values = ["Role", "Group"];

  interface RequestBody {
    userIds?: number[];
    roleIds?: number[];
    groupIds?: number[];
    dashboardIds?: number[];
    tabIds?: number[];
    widgetIds?: number[];
  }

  const handleSearchInput1Change = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchInput1(event.target.value);
  };

  const handleSearchInput2Change = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchInput2(event.target.value);
  };

  const handleSearchInput3Change = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchInput3(event.target.value);
  };

  const handleDropdown1Change = async (value: string) => {
    setDropdown1Value(value);
    setShowAvailableMapping(false);
    try {
      const token = localStorage.getItem("token");
      if (value === "User") {
        const response = await fetch(`${vyu_api_url}/user/allUser`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }
        const data = await response.json();
        const namesArray: any[] = data.map((item: any) => ({
          id: item.userId,
          name: item.email,
        }));
        setNamesForDropdown1(namesArray);
      } else if (value === "Dashboard") {
        const response = await fetch(
          `${vyu_api_url}/dashboard/getAllDashboard`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch Dashboard data");
        }
        const data = await response.json();
        const namesArray: any[] = data.obj.map((item: any) => ({
          id: item.id,
          name: item.name,
        }));
        setNamesForDropdown1(namesArray);
      } else if (value === "Tab") {
        const response = await fetch(`${vyu_api_url}/tab/getAllTab`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch Tab data");
        }
        const data = await response.json();
        const namesArray: any[] = data.obj.map((item: any) => ({
          id: item.id,
          name: item.name,
        }));
        setNamesForDropdown1(namesArray);
      } else if (value === "Role") {
        const response = await fetch(`${vyu_api_url}/role/getAllRoles`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch Role data");
        }
        const data = await response.json();
        const namesArray: any[] = data.obj.map((item: any) => ({
          id: item.roleId,
          name: item.roleName,
        }));
        setNamesForDropdown1(namesArray);
      } else if (value === "Widget") {
        const response = await fetch(`${vyu_api_url}/widget/getAllWidget`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch Widget data");
        }
        const data = await response.json();
        const namesArray: any[] = data.obj.map((item: any) => ({
          id: item.id,
          name: item.name,
        }));
        setNamesForDropdown1(namesArray);
      } else {
        setNamesForDropdown1([]);
      }
    } catch (error) {
      console.error("Error fetching names for dropdown 1:", error);
    }
  };

  const handleDropdown2Change = async (value: string) => {
    setDropdown2Value(value);
    setShowAvailableMapping(false);
    try {
      const token = localStorage.getItem("token");
      if (value === "Role") {
        const response = await fetch(`${vyu_api_url}/role/getAllRoles`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch Role data");
        }
        const data = await response.json();
        const namesArray: any[] = data.obj.map((item: any) => ({
          id: item.roleId,
          name: item.roleName,
        }));
        setNamesForDropdown2(namesArray);
      } else if (value === "Group") {
        const response = await fetch(`${vyu_api_url}/groups/getAllGroups`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch Role data");
        }
        const data = await response.json();
        const namesArray: any[] = data.obj.map((item: any) => ({
          id: item.groupId,
          name: item.groupName,
        }));
        setNamesForDropdown2(namesArray);
      } else {
        setNamesForDropdown2([]);
      }
    } catch (error) {
      console.error("Error fetching names for dropdown 2:", error);
    }
  };

  interface DropdownElement extends HTMLSelectElement {
    value: string;
  }

  function getSelectedCheckboxes(divName: string): HTMLInputElement[] {
    const checkboxArea = document.querySelector(divName);
    if (checkboxArea) {
      const checkboxes = checkboxArea.querySelectorAll<HTMLInputElement>(
        'input[type="checkbox"]'
      );
      return Array.from(checkboxes).filter((checkbox) => checkbox.checked);
    } else {
      console.error(divName + " area not found");
      return [];
    }
  }

  const handleMap = async () => {
    try {
      const dropdown1: DropdownElement = document.getElementById(
        "Component"
      ) as DropdownElement;
      const dropdown2: DropdownElement = document.getElementById(
        "role/group"
      ) as DropdownElement;
      const token = localStorage.getItem("token");

      if (!token) {
        handleError("Authentication token not found. Please login again.");
        return;
      }

      if (!dropdown1.value) {
        handleWarning("Select an entity from dropdown 1");
        return;
      }
      if (!dropdown2.value) {
        handleWarning("Select an entity from dropdown 2");
        return;
      }

      var arr = getSelectedCheckboxes(".checkbox-area-1");
      var entity1 = arr.map((selected) => Number(selected.value));
      if (entity1.length === 0) {
        handleWarning("Please select at least one item from the first section");
        return;
      }

      var arr2 = getSelectedCheckboxes(".checkbox-area-2");
      var entity2 = arr2.map((selected) => Number(selected.value));
      if (entity2.length === 0) {
        handleWarning(
          "Please select at least one item from the second section"
        );
        return;
      }

      var url: string;
      let requestBody: RequestBody = {};
      if (dropdown1.value === "User" && dropdown2.value === "Group") {
        url = `${vyu_api_url}/mapping/userGroupMap`;
        requestBody.userIds = entity1;
        requestBody.groupIds = entity2;
      } else if (dropdown1.value === "User" && dropdown2.value === "Role") {
        url = `${vyu_api_url}/mapping/userRoleMap`;
        requestBody.userIds = entity1;
        requestBody.roleIds = entity2;
      } else if (
        dropdown1.value === "Dashboard" &&
        dropdown2.value === "Group"
      ) {
        url = `${vyu_api_url}/mapping/dashboardGroupMap`;
        requestBody.dashboardIds = entity1;
        requestBody.groupIds = entity2;
      } else if (
        dropdown1.value === "Dashboard" &&
        dropdown2.value === "Role"
      ) {
        url = `${vyu_api_url}/mapping/dashboardRoleMap`;
        requestBody.dashboardIds = entity1;
        requestBody.roleIds = entity2;
      } else if (dropdown1.value === "Tab" && dropdown2.value === "Group") {
        url = `${vyu_api_url}/mapping/tabGroupMap`;
        requestBody.tabIds = entity1;
        requestBody.groupIds = entity2;
      } else if (dropdown1.value === "Tab" && dropdown2.value === "Role") {
        url = `${vyu_api_url}/mapping/tabRoleMap`;
        requestBody.tabIds = entity1;
        requestBody.roleIds = entity2;
      } else if (dropdown1.value === "Role" && dropdown2.value === "Group") {
        url = `${vyu_api_url}/mapping/roleGroupMap`;
        requestBody.roleIds = entity1;
        requestBody.groupIds = entity2;
      } else if (dropdown1.value === "Role" && dropdown2.value === "Role") {
        handleWarning("Can not map role to itself.");
        return;
      } else if (dropdown1.value === "Widget" && dropdown2.value === "Group") {
        url = `${vyu_api_url}/mapping/widgetGroupMap`;
        requestBody.widgetIds = entity1;
        requestBody.groupIds = entity2;
      } else if (dropdown1.value === "Widget" && dropdown2.value === "Role") {
        url = `${vyu_api_url}/mapping/widgetRoleMap`;
        requestBody.widgetIds = entity1;
        requestBody.roleIds = entity2;
      } else {
        handleWarning("Invalid entity selected in dropdown.");
        return;
      }

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(
          errorData?.message || `HTTP error! status: ${response.status}`
        );
      }

      handleSuccess("Mapping success");
    } catch (error) {
      console.error("Mapping error:", error);
      if (error instanceof Error) {
        handleError(`Mapping failed: ${error.message}`);
      } else {
        handleError("An unexpected error occurred during mapping");
      }
    }
  };

  const removeMapping = async () => {
    try {
      const dropdown1: DropdownElement = document.getElementById(
        "Component"
      ) as DropdownElement;
      const dropdown2: DropdownElement = document.getElementById(
        "role/group"
      ) as DropdownElement;
      const token = localStorage.getItem("token");

      if (!token) {
        handleError("Authentication token not found. Please login again.");
        return;
      }

      if (!dropdown1.value) {
        handleWarning("Select an entity from dropdown 1");
        return;
      }
      if (!dropdown2.value) {
        handleWarning("Select an entity from dropdown 2");
        return;
      }

      var arr = getSelectedCheckboxes(".checkbox-area-1");
      var entity1 = arr.map((selected) => Number(selected.value));
      if (entity1.length === 0) {
        handleWarning("Please select at least one item to remove mapping");
        return;
      }

      var arr2 = getSelectedCheckboxes(".checkbox-area-3");
      var entity2 = arr2.map((selected) => Number(selected.value));
      if (entity2.length === 0) {
        handleWarning("Please select at least one mapping to remove");
        return;
      }

      var url: string;
      let requestBody: RequestBody = {};
      if (dropdown1.value === "User" && dropdown2.value === "Group") {
        url = `${vyu_api_url}/mapping/deleteUserGroupMap`;
        requestBody.userIds = entity1;
        requestBody.groupIds = entity2;
      } else if (dropdown1.value === "User" && dropdown2.value === "Role") {
        url = `${vyu_api_url}/mapping/deleteUserRoleMap`;
        requestBody.userIds = entity1;
        requestBody.roleIds = entity2;
      } else if (
        dropdown1.value === "Dashboard" &&
        dropdown2.value === "Group"
      ) {
        url = `${vyu_api_url}/mapping/deleteDashboardGroupMap`;
        requestBody.dashboardIds = entity1;
        requestBody.groupIds = entity2;
      } else if (
        dropdown1.value === "Dashboard" &&
        dropdown2.value === "Role"
      ) {
        url = `${vyu_api_url}/mapping/deleteDashboardRoleMap`;
        requestBody.dashboardIds = entity1;
        requestBody.roleIds = entity2;
      } else if (dropdown1.value === "Tab" && dropdown2.value === "Group") {
        url = `${vyu_api_url}/mapping/deleteTabGroupMap`;
        requestBody.tabIds = entity1;
        requestBody.groupIds = entity2;
      } else if (dropdown1.value === "Tab" && dropdown2.value === "Role") {
        url = `${vyu_api_url}/mapping/deleteTabRoleMap`;
        requestBody.tabIds = entity1;
        requestBody.roleIds = entity2;
      } else if (dropdown1.value === "Role" && dropdown2.value === "Group") {
        url = `${vyu_api_url}/mapping/deleteRoleGroupMap`;
        requestBody.roleIds = entity1;
        requestBody.groupIds = entity2;
      } else if (dropdown1.value === "Role" && dropdown2.value === "Role") {
        handleWarning("Can not delete mapping of role to itself.");
        return;
      } else if (dropdown1.value === "Widget" && dropdown2.value === "Group") {
        url = `${vyu_api_url}/mapping/deleteWidgetGroupMap`;
        requestBody.widgetIds = entity1;
        requestBody.groupIds = entity2;
      } else if (dropdown1.value === "Widget" && dropdown2.value === "Role") {
        url = `${vyu_api_url}/mapping/deleteWidgetRoleMap`;
        requestBody.widgetIds = entity1;
        requestBody.roleIds = entity2;
      } else {
        handleWarning("Invalid entity selected in dropdown.");
        return;
      }

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(
          errorData?.message || `HTTP error! status: ${response.status}`
        );
      }

      const arr3 = availableMappings.filter(
        (item1) => !entity2.includes(item1.id)
      );
      setAvailableMappings(arr3);
      handleSuccess("Removing mapping success");
    } catch (error) {
      console.error("Remove mapping error:", error);
      if (error instanceof Error) {
        handleError(`Failed to remove mapping: ${error.message}`);
      } else {
        handleError("An unexpected error occurred while removing mapping");
      }
    }
  };

  const fetchAvailableMapping = async () => {
    try {
      const dropdown1: DropdownElement = document.getElementById(
        "Component"
      ) as DropdownElement;
      if (!dropdown1.value) {
        handleWarning("Select an entity from dropdown 1");
        return;
      }
      const dropdown2: DropdownElement = document.getElementById(
        "role/group"
      ) as DropdownElement;
      if (!dropdown2.value) {
        handleWarning("Select an entity from dropdown 2");
        return;
      }

      var arr = getSelectedCheckboxes(".checkbox-area-1");
      var entity1 = arr.map((selected) => selected.value);
      if (entity1.length === 0) {
        handleWarning("Please select at least one item to fetch mappings");
        return;
      }

      const token = localStorage.getItem("token");
      if (!token) {
        handleError("Authentication token not found. Please login again.");
        return;
      }

      let url = new URL(vyu_api_url);
      if (dropdown1.value === "User" && dropdown2.value === "Group") {
        url.pathname = "vyu/groups/getGroupsByUserId";
        url.searchParams.append("userIds", entity1.join(","));
      } else if (dropdown1.value === "User" && dropdown2.value === "Role") {
        url.pathname = "vyu/role/getRolesByUserId";
        url.searchParams.append("userIds", entity1.join(","));
      } else if (
        dropdown1.value === "Dashboard" &&
        dropdown2.value === "Group"
      ) {
        url.pathname = "vyu/groups/getGroupByDashboardId";
        url.searchParams.append("dashboardIds", entity1.join(","));
      } else if (
        dropdown1.value === "Dashboard" &&
        dropdown2.value === "Role"
      ) {
        url.pathname = "vyu/role/getRolesByDashboardId";
        url.searchParams.append("dashboardIds", entity1.join(","));
      } else if (dropdown1.value === "Tab" && dropdown2.value === "Group") {
        url.pathname = "vyu/groups/getGroupsByTabId";
        url.searchParams.append("tabIds", entity1.join(","));
      } else if (dropdown1.value === "Tab" && dropdown2.value === "Role") {
        url.pathname = "vyu/role/getRolesByTabId";
        url.searchParams.append("tabIds", entity1.join(","));
      } else if (dropdown1.value === "Role" && dropdown2.value === "Group") {
        url.pathname = "vyu/groups/getGroupsByRoleId";
        url.searchParams.append("roleIds", entity1.join(","));
      } else if (dropdown1.value === "Role" && dropdown2.value === "Role") {
        handleError("Can not fetch mapping of role to itself.");
        return;
      } else if (dropdown1.value === "Widget" && dropdown2.value === "Group") {
        url.pathname = "vyu/groups/getGroupsByWidgetId";
        url.searchParams.append("widgetIds", entity1.join(","));
      } else if (dropdown1.value === "Widget" && dropdown2.value === "Role") {
        url.pathname = "vyu/role/getRolesByWidgetId";
        url.searchParams.append("widgetIds", entity1.join(","));
      } else {
        handleWarning("Invalid entity selected in dropdown.");
        return;
      }

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(
          errorData?.message || `HTTP error! status: ${response.status}`
        );
      }

      const data = await response.json();
      if (!data || !data.obj) {
        throw new Error("Invalid response format from server");
      }

      const objArray = data.obj;
      const newObjectsArray = [];
      for (let i = 0; i < objArray.length; i++) {
        const newObj = {
          roleId: i + 1,
          value: objArray[i],
        };
        newObjectsArray.push(newObj);
      }

      var array1: any[] = data.obj.map((item: any) => ({
        roleId: item,
      }));
      var array2 = namesForDropdown2;
      var resultArray = array2.map(function (item) {
        var role = array1.find(function (roleItem) {
          if (roleItem.roleId === item.id) return roleItem;
        });
        return role ? { id: item.id, name: item.name } : null;
      });
      resultArray = resultArray.filter(function (item) {
        return item !== null;
      });
      setAvailableMappings(resultArray);
    } catch (error) {
      console.error("Fetch available mapping error:", error);
      if (error instanceof Error) {
        handleError(`Failed to fetch mappings: ${error.message}`);
      } else {
        handleError("An unexpected error occurred while fetching mappings");
      }
    }
  };

  const showCopyDiv = () => {
    setShowMappingDiv(true);
    setShowAvailableMapping(false);
  };

  const handleCopy = async () => {
    try {
      const dropdown1: DropdownElement = document.getElementById(
        "Component"
      ) as DropdownElement;
      if (!dropdown1.value) {
        handleWarning("Select an entity from dropdown 1");
        return;
      }

      const token = localStorage.getItem("token");
      if (!token) {
        handleError("Authentication token not found. Please login again.");
        return;
      }

      var arr = getSelectedCheckboxes(".checkbox-area-1");
      var entity1 = arr.map((selected) => Number(selected.value));
      if (!entity1.length) {
        handleWarning("Select at least one source entity.");
        return;
      }

      var arr2 = getSelectedCheckboxes(".checkbox-area-5");
      var entity2 = arr2.map((selected) => Number(selected.value));
      if (!entity2.length) {
        handleWarning("Select at least one target entity.");
        return;
      }

      let url = new URL(vyu_api_url);
      if (dropdown1.value === "User") {
        url.pathname = "vyu/mapping/copyUserMapping";
        url.searchParams.append("sourceUserIds", entity1.join(","));
        url.searchParams.append("targetUserIds", entity2.join(","));
      } else if (dropdown1.value === "Dashboard") {
        url.pathname = "vyu/mapping/copyDashboardMapping";
        url.searchParams.append("sourceDashboardIds", entity1.join(","));
        url.searchParams.append("targetDashboardIds", entity2.join(","));
      } else if (dropdown1.value === "Tab") {
        url.pathname = "vyu/mapping/copyTabMapping";
        url.searchParams.append("sourceTabIds", entity1.join(","));
        url.searchParams.append("targetTabIds", entity2.join(","));
      } else if (dropdown1.value === "Role") {
        url.pathname = "vyu/mapping/copyRoleMapping";
        url.searchParams.append("sourceRoleIds", entity1.join(","));
        url.searchParams.append("targetRoleIds", entity2.join(","));
      } else if (dropdown1.value === "Widget") {
        url.pathname = "vyu/mapping/copyWidgetMapping";
        url.searchParams.append("sourceWidgetIds", entity1.join(","));
        url.searchParams.append("targetWidgetIds", entity2.join(","));
      } else {
        handleError("Invalid entity selected in dropdown 1.");
        return;
      }

      const response = await fetch(url.toString(), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(
          errorData?.message || `HTTP error! status: ${response.status}`
        );
      }

      handleSuccess("Cloning success");
    } catch (error) {
      console.error("Copy mapping error:", error);
      if (error instanceof Error) {
        handleError(`Failed to copy mappings: ${error.message}`);
      } else {
        handleError("An unexpected error occurred while copying mappings");
      }
    }
  };

  const handleWarning = (message: string) => {
    showWarningToast(message);
  };
  const handleSuccess = (message: string) => {
    showSuccessToast(message);
  };
  const handleError = (message: string) => {
    showErrorToast(message);
  };
  const inputStyle =
    "form-control block w-full px-3 py-2 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded-md transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none";

  const selectStyle = "form-select " + inputStyle;
  const smallRadius = { borderRadius: "4px", borderColor: "#E0E0E0" };
  const inputBorderStyle = { borderColor: "#D0D5DD", borderRadius: "4px" };
  return (
    <div className="column h-100 g-3">
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: "8px",
        }}
      >
        <div
          className="column g-3"
          style={{
            display: "flex",
            width: "40%",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "8px",
            // border: "1px solid black",
          }}
        >
          <Button
            color="primary"
            // className="w-100 p-3"
            className="submit-button"
            onClick={handleMap}
          >
            Map
          </Button>

          <Button
            color="storybook"
            isLight={true}
            // className="w-100 p-3"
            className="submit-reset"
            style={{ border: "1px solid #d0d5dd" }}
            onClick={fetchAvailableMapping}
          >
            Fetch Availale Mapping
          </Button>

          <Button
            color="primary"
            // className="w-100 p-3"
            className="submit-button"
            onClick={showCopyDiv}
          >
            Copy Mappings
          </Button>
        </div>
      </div>

      <div className="row g-4">
        <div className="col-6 mb-4">
          <Card stretch style={{ borderRadius: "4px" }}>
            <CardBody isScrollable>
              <div className="row g-2">
                <div className="col-lg-8">
                  <FormGroup label="Component">
                    <Select
                      ariaLabel="State"
                      placeholder="Select Component..."
                      style={smallRadius}
                      className={selectStyle}
                      id="Component"
                      name="Component"
                      value={dropdown1Value}
                      onChange={(e: any) =>
                        handleDropdown1Change(e.target.value)
                      }
                    >
                      {section1Values.map((val: any, index) => (
                        <option className="italic" key={index} value={val}>
                          {val}
                        </option>
                      ))}
                    </Select>
                  </FormGroup>
                </div>
                <div className="col-lg-4">
                  <FormGroup label="Search">
                    <Input
                      type="text"
                      placeholder="Search..."
                      style={smallRadius}
                      className={inputStyle}
                      value={searchInput1}
                      onChange={handleSearchInput1Change}
                    />
                  </FormGroup>
                </div>
              </div>
              <div className="checkbox-area-1 mt-5">
                {namesForDropdown1
                  .filter((name) =>
                    name.name.toLowerCase().includes(searchInput1.toLowerCase())
                  )
                  .map((name) => (
                    <div>
                      <input
                        key={name.name + name.id}
                        value={name.id}
                        type="checkbox"
                        className="custom-checkbox"
                      />
                      <label className="ml-5">{name.name}</label>
                    </div>
                  ))}
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-6 mb-4">
          <Card stretch style={{ borderRadius: "4px" }}>
            <CardBody isScrollable>
              <div className="row g-2">
                <div className="col-md-8">
                  <FormGroup label="Role/Group">
                    <Select
                      ariaLabel="Role/Group"
                      placeholder="Select Role/Group..."
                      style={smallRadius}
                      className={selectStyle}
                      id="role/group"
                      name="role/group"
                      value={dropdown2Value}
                      onChange={(e: any) =>
                        handleDropdown2Change(e.target.value)
                      }
                    >
                      {section2Values.map((val: any, index) => (
                        <option className="italic" key={index} value={val}>
                          {val}
                        </option>
                      ))}
                    </Select>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup label="Search">
                    <Input
                      type="text"
                      placeholder="Search..."
                      style={smallRadius}
                      className={inputStyle}
                      value={searchInput2}
                      onChange={handleSearchInput2Change}
                    />
                  </FormGroup>
                </div>
              </div>
              <div className="checkbox-area-2 mt-4">
                {namesForDropdown2
                  .filter((name) =>
                    name.name.toLowerCase().includes(searchInput2.toLowerCase())
                  )
                  .map((name) => (
                    <div>
                      <input
                        key={name.name + name.id}
                        value={name.id}
                        type="checkbox"
                        className="custom-checkbox"
                      />
                      <label>{name.name}</label>
                    </div>
                  ))}
              </div>
            </CardBody>
          </Card>
        </div>
      </div>

      <div className="col-lg-12">
        <Card stretch style={{ borderRadius: "4px" }}>
          <CardHeader>Mapping</CardHeader>
          <CardBody>
            <div className="row g-3">
              {showAvailableMapping && (
                <div className="col-12">
                  <div>
                    Available Mapping for selected {dropdown1Value}(s) with{" "}
                    {dropdown2Value}
                  </div>
                  {availableMappings.map((name) => (
                    <div className="col-12">
                      <FormGroup>
                        <input
                          type="checkbox"
                          key={name.name + name.id}
                          name={name.name}
                          aria-label="pr"
                          style={{ marginRight: "2%" }}
                        />
                        <label>{name.name}</label>
                      </FormGroup>
                    </div>
                  ))}
                </div>
              )}
              {showAvailableMapping && (
                <Button
                  onClick={removeMapping}
                  color="danger"
                  isLight={true}
                  className="w-50"
                >
                  Remove
                </Button>
              )}
              {showMappingDiv && (
                <div className="col-12">
                  Select target {dropdown1Value}(s) to which you want to copy
                  the common mapping of selected {dropdown1Value}(s)
                  <br />
                  <FormGroup>
                    <Input
                      type="text"
                      placeholder="Search..."
                      value={searchInput3}
                      onChange={handleSearchInput3Change}
                    />
                  </FormGroup>
                  <div>
                    {namesForDropdown1
                      .filter((name) =>
                        name.name
                          .toLowerCase()
                          .includes(searchInput3.toLowerCase())
                      )
                      .map((name) => (
                        <div className="col-12">
                          <FormGroup>
                            <input
                              type="checkbox"
                              key={name.name + name.id}
                              name={name.name}
                              aria-label="pr"
                            />
                            <label>{name.name}</label>
                          </FormGroup>
                        </div>
                      ))}
                  </div>
                </div>
              )}
              {showMappingDiv && (
                <Button
                  className="w-50"
                  color="primary"
                  isLight={true}
                  onClick={handleCopy}
                >
                  Copy
                </Button>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
      <ToastComponent />
    </div>
  );
};

export default MappingScreen;
